import React from "react";
import { VictoryChart,  VictoryAxis, VictoryTooltip, VictoryScatter, VictoryLabel, VictoryLine, createContainer } from "victory";
import victoryDarkTheme from "themes/victory-theme";
import {blue} from "@material-ui/core/colors";
import {Box} from "@material-ui/core";
import { format, fromUnixTime } from "date-fns";
import { GraphData } from "entities/graph-data";

interface VoltageGraphProps {
    title: string;
    unit: string;
    data: GraphData[];
}

const Graph: React.FC<VoltageGraphProps> = (props) => {
    const { data, unit } = props;

    const x = "dateTime";
    const y = "value";
    const sortKey = x;

    const values = data.map(data => data.value).filter(value => value !== null) as number[];
    const minValue = Math.min(...values);
    const minFloor = Math.floor(minValue);
    const maxValue = Math.max(...values);
    const maxCeil = Math.ceil(maxValue);

    const VictoryZoomVoronoiContainer = createContainer("zoom", "voronoi") as any;

    return (
        <Box>
            <VictoryChart
                theme={victoryDarkTheme}
                containerComponent={
                    <VictoryZoomVoronoiContainer/>
                }
                domainPadding={{ y:[ 25 , 25 ] }}
            >
                <VictoryLine
                    data={data}
                    x={x}
                    y={y}
                    sortKey={sortKey}
                    interpolation="monotoneX"
                    animate={{ onLoad: { duration: 500 }}}
                    style={{
                        data: { stroke: blue[500], strokeWidth: 3 }
                    }}
                />
                <VictoryAxis
                    domain={{ y: [ minFloor -1, maxCeil ]}}
                    tickCount={maxCeil - minFloor + 1}
                    tickFormat={value => `${value} ${unit}`}
                    dependentAxis={true}
                    crossAxis={false}
                />
                <VictoryAxis
                    tickCount={30}
                    tickLabelComponent={<VictoryLabel angle={-35} textAnchor="end"/>}
                    tickFormat={(value) => format(fromUnixTime(value), "dd. MM. HH:mm")}
                    offsetY={80}
                />
                <VictoryScatter
                    labels={({datum}) =>
                        `${format(fromUnixTime(datum.dateTime), "d.M. yyyy - HH:mm")}\n-\n` +
                        `${datum.value ?? "-"} ${unit}`
                    }
                    labelComponent={
                        <VictoryTooltip
                            cornerRadius={4}
                            flyoutStyle={{
                                fill: "#002855",
                                stroke: "#2166f0",
                            }}
                            pointerWidth={8}
                        />
                    }
                    size={0}
                    data={data}
                    x={x}
                    y={y}
                    sortKey={sortKey}
                    style={{ data: { fill: blue[500] } }}
                />
            </VictoryChart>
        </Box>
    );
}

export default Graph;
